import { render, staticRenderFns } from "./Formulario.vue?vue&type=template&id=def43176"
import script from "./Formulario.vue?vue&type=script&lang=js"
export * from "./Formulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports